import { USE_MOCK_API } from './httpClient'
import * as mock from './nearby.mock'
import * as http from './nearby.http'

const impl = USE_MOCK_API ? mock : http

export const getNearby = impl.getNearby
